import { Button, useMediaQuery, Box, Flex } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import FormField from 'components/FormField';
import PasswordRulesChecklist from 'components/PasswordRulesChecklist';
import { SetAuthPasswordPageType, SetAuthPassword, SetAuthPageType } from 'redux/AuthSlice';
import { ChangePasswordSchema } from 'validation/schemas/AuthenticationSchema';

const initialValues = {
  password: '',
  confirmPassword: '',
};

const SetPasswordForm = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();

  const [isMobile] = useMediaQuery('(max-width: 600px)');

  const onSubmitForm = (form: { password: string }) => {
    dispatch(SetAuthPassword(form.password));
    dispatch(SetAuthPasswordPageType(2));
  };

  const goBackToLogin = () => {
    navigate('/');
    dispatch(SetAuthPageType(1));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmitForm}
      validationSchema={ChangePasswordSchema}
    >
      {({ errors, touched, values, submitCount }) => (
        <Form>
          <Box display='flex' flexDirection='column' rowGap='2'>
            <FormField
              label='Set password:'
              name='password'
              type='password'
              labelStyles={{
                fontSize: '0.875rem',
                color: '#121826',
              }}
              inputStyles={{
                maxWidth: '18.75rem',
                boxShadow: '0 0 0 0.0625rem #7A849E',
              }}
              placeholder='Password'
              error={errors.password}
              touched={touched.password}
            />
            <FormField
              label='Confirm password:'
              name='confirmPassword'
              type='password'
              labelStyles={{
                fontSize: '0.875rem',
                color: '#121826',
              }}
              inputStyles={{
                maxWidth: '18.75rem',
                boxShadow: '0 0 0 0.0625rem #7A849E',
              }}
              placeholder='Password'
              error={errors.confirmPassword}
              touched={touched.confirmPassword}
            />
          </Box>
          <Flex
            mt='1'
            alignItems={isMobile ? 'stretch' : 'center'}
            justifyContent='space-between'
            flexDirection={isMobile ? 'column' : 'row'}
            gap='4'
            maxWidth='32.5rem'
          >
            <PasswordRulesChecklist password={values.password} submitCount={submitCount} />
            <Box
              display='flex'
              flexDirection='column'
              alignItems={isMobile ? 'stretch' : 'center'}
              ml={isMobile ? 0 : '8'}
            >
              <Button
                type='submit'
                w={isMobile ? '100%' : '9.375rem'}
                height='2.125rem'
                borderRadius='xs'
                fontSize='xs'
                bgColor='green.900'
              >
                Continue
              </Button>
              <small
                style={{
                  width: isMobile ? '100%' : '9.375rem',
                  textAlign: 'center',
                  marginTop: '0.7rem',
                  cursor: 'pointer',
                  color: '#939393',
                  textDecoration: 'underline',
                  display: 'block',
                }}
                onClick={goBackToLogin}
              >
                Back to login
              </small>
            </Box>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};

export default SetPasswordForm;
